import { AssetManagerProjectCardWithTabsTemplate } from "../../../../templates/AssetManagerProjectCardWithTabsTemplate";
import { useProject } from "./useProject";

const Project = (): JSX.Element => {
  const { handleBackClick, tabsList, backButtonText } = useProject();

  return (
    <AssetManagerProjectCardWithTabsTemplate
      activeElement="Portfolio"
      tabsList={tabsList}
      backButtonText={backButtonText}
      handleBackClick={handleBackClick}
    />
  );
};

export default Project;
